import { useTranslation } from 'react-i18next';
import type { ParseKeys } from 'i18next';
import {
  BookPlus,
  FileText,
  FolderPlus,
  LayoutList,
  Rocket,
  ScanSearch,
  Sparkles,
} from 'lucide-react';

interface Suggestion {
  label: ParseKeys<'adminAssistant'>;
  prompt: ParseKeys<'adminAssistant'>;
  icon: typeof BookPlus;
}

const COURSE_SUGGESTIONS: Suggestion[] = [
  {
    label: 'empty.context.review',
    prompt: 'empty.context.reviewPrompt',
    icon: ScanSearch,
  },
  {
    label: 'empty.context.describe',
    prompt: 'empty.context.describePrompt',
    icon: FileText,
  },
  {
    label: 'empty.context.publish',
    prompt: 'empty.context.publishPrompt',
    icon: Rocket,
  },
];

const SUGGESTIONS: Suggestion[] = [
  {
    label: 'empty.suggestions.newCourse',
    prompt: 'empty.suggestions.newCoursePrompt',
    icon: BookPlus,
  },
  {
    label: 'empty.suggestions.addModule',
    prompt: 'empty.suggestions.addModulePrompt',
    icon: FolderPlus,
  },
  {
    label: 'empty.suggestions.status',
    prompt: 'empty.suggestions.statusPrompt',
    icon: LayoutList,
  },
];

interface AssistantEmptyStateProps {
  disabled: boolean;
  onCoursePage: boolean;
  onPick: (prompt: string) => void;
}

export function AssistantEmptyState({
  disabled,
  onCoursePage,
  onPick,
}: AssistantEmptyStateProps) {
  const suggestions = onCoursePage
    ? [...COURSE_SUGGESTIONS, SUGGESTIONS[0]]
    : SUGGESTIONS;
  const { t } = useTranslation('adminAssistant');

  return (
    <div className="flex min-h-0 flex-1 flex-col justify-end gap-5 overflow-y-auto px-4 py-6">
      <div className="space-y-2">
        <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-primary/15 text-primary-ink">
          <Sparkles className="h-5 w-5" />
        </div>
        <h2 className="font-display text-lg font-semibold text-foreground">
          {t('empty.title')}
        </h2>
        <p className="text-sm leading-relaxed text-muted-foreground">
          {t('empty.description')}
        </p>
      </div>
      <div className="flex flex-col gap-2">
        {suggestions.map((suggestion) => (
          <button
            key={suggestion.label}
            type="button"
            disabled={disabled}
            onClick={() => onPick(t(suggestion.prompt))}
            className="flex items-center gap-3 rounded-xl border border-border/50 bg-secondary/30 px-3 py-2.5 text-left text-sm text-foreground transition-colors hover:border-primary/40 hover:bg-primary/5 disabled:opacity-50"
          >
            <suggestion.icon className="h-4 w-4 shrink-0 text-primary-ink" />
            {t(suggestion.label)}
          </button>
        ))}
      </div>
    </div>
  );
}
